import { DocumentRowData, NewGeneratorRequest } from '../../documents/types/documents.type';
import { Injectable, inject } from '@angular/core';
import { ApiHttpClient } from '../../../../core/services/api.http.client.service';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root',
})
export class DocumentApiService {
  private readonly http = inject(ApiHttpClient);

  public getDocumentById(id: string): Observable<DocumentRowData> {
    return this.http.get<DocumentRowData>(`documents/${id}`);
  }

  public updateDocument(id: string, request: NewGeneratorRequest): Observable<{ id: string }> {
    return this.http.put<{ id: string }>(`documents/${id}`, request);
  }
}
